import React from "react";
import LargeHubLinkSection from "./LargeHubLinkSection";

const SuppertCards = () => {
  const sectionTitle = "Support";
  const cardList = [
    {
      title: "Help Center",
      subTitle: "Find the help you need to make the most of Mode",
      buttonHref: "https://mode.com/help/",
    },
    {
      title: "Developer",
      subTitle: "Make the most of Mode with our fully documented API",
      buttonHref: "https://mode.com/developer/api-reference/introduction/",
    },
  ];
  return (
    <LargeHubLinkSection sectionTitle={sectionTitle} cardList={cardList} />
  );
};

export default SuppertCards;
